import type { SVGProps } from "react";

export default function DocumentAnalysisSidebarIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3329 3.33472C15.1454 3.34481 16.127 3.42518 16.7673 4.0655C17.4995 4.79773 17.4995 5.97625 17.4995 8.33326V13.3333C17.4995 15.6903 17.4995 16.8688 16.7673 17.601C16.035 18.3333 14.8565 18.3333 12.4995 18.3333H7.49954C5.14251 18.3333 3.964 18.3333 3.23177 17.601C2.49953 16.8688 2.49953 15.6903 2.49953 13.3333V8.33326C2.49953 5.97625 2.49953 4.79773 3.23177 4.0655C3.87208 3.42518 4.85368 3.34481 6.6662 3.33472"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M8.75019 11.6667H14.1669"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M5.83298 11.6667H6.25012"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M5.83298 8.74976H6.25012"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M5.83298 14.5835H6.25012"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.75019 8.74976H14.1669"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.75019 14.5835H14.1669"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M6.66634 2.91675C6.66634 2.22639 7.22599 1.66675 7.91634 1.66675H12.083C12.7733 1.66675 13.333 2.22639 13.333 2.91675V3.75008C13.333 4.44044 12.7733 5.00008 12.083 5.00008H7.91634C7.22599 5.00008 6.66634 4.44044 6.66634 3.75008V2.91675Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
